class ExamSessionToggleSubmitButton {
  get form() {
    return window.exam_session_answer_form;
  }

  get submitAnswer() {
    return window.btn_submit_answer;
  }

  get optionInputs() {
    return this.form.querySelectorAll('input[name="exam_session_answer[selected_option_ids][]"]');
  }

  init() {
    if (!this.form) return;

    this.setupEvents();
    this.toggleSubmitButton();
  }

  setupEvents() {
    document.addEventListener("turbo:before-cache", this);
    this.form.addEventListener("change", this);
  }

  handleEvent(e) {
    if (e.type === "change") this.toggleSubmitButton()
    else if (e.type === "turbo:before-cache") this.destroy();
  }

  toggleSubmitButton() {
    const anyChecked = Array.from(this.optionInputs).some(input => input.checked);
    this.submitAnswer.disabled = !anyChecked;
  }

  destroy() {
    this.form?.removeEventListener("change", this);
    document.removeEventListener("turbo:before-cache", this);
  }
}

document.addEventListener("turbo:load", () => {
  const toggler = new ExamSessionToggleSubmitButton();
  toggler.init();
});
